import React, { Component } from 'react';
import { isEmpty, size } from "lodash";
import Typography from '@mui/material/Typography';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableFooter from '@mui/material/TableFooter';
import TablePagination from '@mui/material/TablePagination';
import Pagination from '../../../container/MUI/Pagination';
import Button from '@mui/material/Button';
import AddCircleIcon from "@mui/icons-material/AddCircle";
import BanksForm from './BanksForm';
import { Edit, CloudDownloadRounded } from '@mui/icons-material';
import { Box, IconButton } from '@mui/material';
import BankSingle from './BankSingle';
import DownloadProgress from '../Extracts/DownloadProgress';
import TableFooterPagination from '../../../container/MUI/TableFooterPagination';
import Currency from '../../common/Currency';
import { SearchBarV2 } from '../../common/SearchBar';


class BanksList extends Component {
    state = { 
        page: 0,
        rowsPerPage: 15,
        openForm: false,
        openUpdate: false,
        selected: {},
        openDetails: false,
        selectedBank: {},
        loading: false,
        url: "",
        searchBank: "",
    }
    handleDownload = async ()  => {
        this.setState({loading: true, url: "/extract/banks"})
    }
    handleChangePage = (event, page) => {
        this.setState({ page });
    };

    handleChangeRowsPerPage = event => {
        this.setState({ page: 0, rowsPerPage: parseInt(event.target.value) });
    };

    componentDidMount() {
        window.scrollTo(0, 0);
        if(isEmpty(this.props.INCOMES)){
            this.props.fetchIncomes()
        }   
        if(isEmpty(this.props.POSTS)){
            this.props.fetchPosts()
        }  
    }

    handleClose = () => {
		this.setState({ 
            openForm: false,
            openUpdate: false,
            openDetails: false,
            selected: {},
            selectedBank: {},
        });
    };    
    handleChange = (e) => {
        this.setState({ searchBank: e.target.value });
    };
    getFilteredList = () => {
        const { BANKS } = this.props;
        const { searchBank } = this.state;
        let list = Object.values(BANKS)

        console.log('====================================');
        console.log({searchBank});
        console.log('====================================');
        if(!isEmpty(searchBank)){
            list = list.filter( bank => 
                bank.bank_name.toLowerCase().includes(searchBank.toLowerCase()) ||
                bank.bank_desc.toLowerCase().includes(searchBank.toLowerCase()) 
                )
        }
        return list
    }

    displayList = () => {
        const { BANKS } = this.props;
        let tab = []
        let rows = 0
        if (!isEmpty(BANKS)){
            let all = this.getFilteredList()            
            rows = size(all)
            console.log('====================================');
            console.log({all, rows});
            console.log('====================================');
            tab.push(this.getBanksList(all))
        }
        return {tab, rows}
    }
    getBanksList = (list) => {
        const { rowsPerPage, page } = this.state;
        if (!isEmpty(list)){
            return list.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(item => {
                return (
                    <TableRow hover key={item.bank_id} className="clickable">
                        <TableCell 
                            onClick={ () => this.setState({ openDetails: true, selectedBank: item})}
                        >{item.bank_name}</TableCell>                     
                        <TableCell 
                            onClick={ () => this.setState({ openDetails: true, selectedBank: item})}
                        >{item.bank_desc}</TableCell>                     
                        <TableCell 
                            onClick={ () => this.setState({ openDetails: true, selectedBank: item})}
                        ><Currency value={item.bank_solde} /></TableCell>                     
                        <TableCell>
                            <IconButton 
                                color="secondary"
                                size="small" 
                                onClick={ () => this.setState({openUpdate: true, selected: item}) }
                            >
                                <Edit />
                            </IconButton> 
                        </TableCell>                                                   
                        <TableCell>
                            <IconButton 
                                color="primary" 
                                size="small"
                                onClick={
                                    () => this.props.openFormDownload(
                                        "/extract/in/out", 
                                        `Extract Banque ${item.bank_name}`, 
                                        `MJB_tresorerie_${item.bank_name}.csv`, 
                                        item.bank_id
                                    )
                                } 
                                title="Télécharger" disabled={this.props.downloading}
                            >
                                <CloudDownloadRounded />
                            </IconButton>
                        </TableCell>                                                   

                    </TableRow>
                )
            })
        }
    }

    render() {
        const { openForm, rowsPerPage, page, openUpdate, selected, openDetails, selectedBank } = this.state;
        const { BANKS } = this.props;
        let total = 0
        if (!isEmpty(BANKS) ){
            Object.values(BANKS).forEach(bank => {
                total += bank.bank_solde || 0
            })
        }
        let data = this.displayList()
        return (
            <div>
                {openForm &&
                    <BanksForm open={openForm} handleClose={this.handleClose} {...this.props} />
                }
                {openUpdate && !isEmpty(selected) &&
                    <BanksForm 
                        update 
                        bank={selected} 
                        open={openUpdate} 
                        handleClose={this.handleClose} 
                        {...this.props} 
                    />
                }
                {openDetails && !isEmpty(selectedBank) &&
                    <BankSingle
                        open={openDetails} 
                        bank={selectedBank}
                        handleClose={this.handleClose} 
                        {...this.props} 
                    />
                }
                {this.state.loading && this.state.url &&
                    <DownloadProgress
                        {...this.state}
                        handleLoading={(loading) => this.setState({ loading })}
                    />  
                }
                <Typography variant="h6" id="tableTitle">
                    Liste des Banques
                </Typography>

                <Box p={1}>
                    {!isEmpty(BANKS) &&
                        <Typography variant="h6" color="primary"><b>Solde Total : <Currency value={total} /></b></Typography>
                    }
                </Box>

                <SearchBarV2
                    handleChange={this.handleChange} 
                    label="Rechercher"
                    searchValue={this.state.searchBank}
                >
                    <Box style={{ display: 'flex'}}>
                        <Button variant="contained" color="secondary" 
                            onClick={() => this.setState({ openForm: true})} title="Nouvelle Banque">
                            <AddCircleIcon />
                            Ajouter
                        </Button>
                        <IconButton color="primary" onClick={ () => this.props.handleDownload("/extract/banks", "MJB_banques.csv") } disabled={this.props.downloading}>
                            <CloudDownloadRounded />
                        </IconButton>
                        
                    </Box>
                </SearchBarV2>
                    
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>Nom</TableCell>
                            <TableCell>Description</TableCell>
                            <TableCell>Solde</TableCell>
                            <TableCell>Modifier</TableCell>
                            <TableCell>Balance</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {data.tab}
                    </TableBody>
                    {data.rows > 10 &&
                        <TableFooterPagination
                            rowsPerPageOptions={[15, 30]}
                            colSpan={5}
                            count={data.rows}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            // SelectProps={{
                            //     native: true,
                            // }}
                            onPageChange={this.handleChangePage}
                            onRowsPerPageChange={this.handleChangeRowsPerPage}
                            // ActionsComponent={Pagination}
                        />
                            
                    }
                </Table> 
            </div>
        );
    }
}

export default BanksList;